export const LOGO_HEIGHT = {
  header: 36,
  footer: 24
};

export const LOGO_ASPECT_RATIO = 4;

export const IMAGE = {
  default: 300,
  wide: 600,
  tall: 600
};

export const ASPECT_RATIO = {
  square: 1,
  wide: 2,
  narrow: 1 / 2
};

export const PERCENT_HORIZONTAL = {
  initial: 80,
  sm: 85,
  md: 80,
  lg: 75
};
export const PERCENT_VERTICAL = {
  initial: 80,
  sm: 85,
  md: 80,
  lg: 75
};

export const NAVIGATION_ITEMS_IN_ROW = 3;
